import Repository from '../../repositories/RepositoryFactory';
import axios from '@/plugins/axios';
import { RepoError } from '../../../lib/Errors';
const releaseNotesRepository = Repository.get('releaseNotes');

export default {
	namespaced: true,
	state: {
		releaseNote: null,
		releaseNotes: [],
		jobs: [],
	},
	mutations: {
		STORE_RELEASE_NOTES (state, payload) {
			state.releaseNotes = payload;
		},
		STORE_RELEASE_NOTE (state, payload) {
			state.releaseNote = payload;
		},
		REMOVE_RELEASE_NOTE (state, id) {
			state.releaseNotes = state.releaseNotes.filter((note) => note.id !== id);
		},
		UPDATE_JOB (state, payload) {
			const jobIndex = state.jobs.findIndex((job) => job.id === payload.id);
			if (jobIndex !== -1) {
				state.jobs[jobIndex] = payload;
			} else {
				state.jobs.unshift(payload);
			}
		},
		DELETE_JOB (state, id) {
			state.jobs = state.jobs.filter((job) => job.id !== id);
		},
	},
	actions: {
		async getAllReleaseNotes ({ commit }) {
			const response = await releaseNotesRepository.getAllReleaseNotes();
			commit('STORE_RELEASE_NOTES', response.data ?? []);
		},
		async getReleaseNoteById ({ commit }, body) {
			const payload = {
				id: new Date().getTime(),
				fileName: body.fileName,
				percentage: 0,
				status: 'downloading',
				direction: 'download',
				totalSize: 0,
				completedSize: 0,
			};
			try {
				const response = await axios
					.get(`/releasenote/${body.id}`, {
						responseType: 'blob',
						onDownloadProgress: function (progressEvent) {
							payload.totalSize = progressEvent.total;
							payload.completedSize = progressEvent.loaded;
							payload.percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
							commit('UPDATE_JOB', payload);
						},
					})
					.catch(function () {
						payload.status = 'failed';
						commit('UPDATE_JOB', payload);
					});

				payload.status = 'completed';
				commit('UPDATE_JOB', payload);
				commit('STORE_RELEASE_NOTE', response.data ?? null);

				// const response = await ccmImagingRepository.getCCMImaging(id);
			} catch (error) {
				throw new RepoError('Error getting release note by ID');
			}
		},
		async addReleaseNote ({ commit }, body) {
			const payload = {
				id: new Date().getTime(),
				fileName: body.get('File').name,
				percentage: 0,
				status: 'uploading',
				direction: 'upload',
				totalSize: body.get('File').size,
				completedSize: 0,
			};
			try {
				await axios
					.post('/releasenote/', body, {
						onUploadProgress: function (progressEvent) {
							payload.percentage = parseInt((progressEvent.loaded / progressEvent.total) * 100);
							payload.completedSize = progressEvent.loaded;
							commit('UPDATE_JOB', payload);
						},
					})
					.then(function () {
						payload.status = 'completed';
						commit('UPDATE_JOB', payload);
						return true;
					})
					.catch(function () {
						payload.status = 'failed';
						commit('UPDATE_JOB', payload);
					});
			} catch (error) {
				throw new RepoError('Error adding release note');
			}
		},
		async deleteReleaseNote ({ commit }, id) {
			commit('REMOVE_RELEASE_NOTE', id);
			return await releaseNotesRepository.deleteReleaseNote(id);
		},
	},
};
